var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
define(["require", "exports", "vue", "noty", "vee-validate", "vee-validate/dist/locale/de", "../Components/CustomThumbnailComponent", "../Components/ColorPickerComponent", "../Shared/KendoDataExtracter", "./BasicViewControllerWithCRUDDataSource"], function (require, exports, vue_1, Noty, vee_validate_1, german, CustomThumbnailComponent_1, ColorPickerComponent_1, KendoDataExtracter_1, BasicViewControllerWithCRUDDataSource_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var ContentDetailController = (function (_super) {
        __extends(ContentDetailController, _super);
        function ContentDetailController(options_, vueInitiatorObjectOverrides) {
            if (vueInitiatorObjectOverrides === void 0) { vueInitiatorObjectOverrides = {}; }
            var _this = this;
            var ct = new CustomThumbnailComponent_1.CustomThumbnailComponent();
            var test = new ColorPickerComponent_1.ColorPickerComponent();
            _this = _super.call(this, options_) || this;
            vue_1.default.use(vee_validate_1.default);
            _this.vueRoot.$validator.localize("de", {
                messages: german.messages
            });
            _this.GetUsageCount();
            return _this;
        }
        Object.defineProperty(ContentDetailController.prototype, "retranscodeApiUrl", {
            get: function () {
                return "/api/v1/contents/" + this.vueRoot.model.Id + "/transcode";
            },
            enumerable: true,
            configurable: true
        });
        ContentDetailController.prototype.GetUsageCount = function () {
            var _this = this;
            $.get(this.options.usageCountApiUrl).done(function (response) {
                _this.vueRoot.usageCount = response.Count;
            });
        };
        ContentDetailController.prototype.initVue = function () {
            var _this = this;
            var base = this;
            this.vueRoot = new vue_1.default({
                el: this.options.htmlElementSelector,
                data: {
                    vueRoot: this,
                    model: this.GetNewInstanceOfType(this.options.type),
                    showModal: false,
                    options1: [],
                    options2: [],
                    locations: [],
                    modal: {
                        message: '',
                        callBackName: ''
                    },
                    retranscodeRunning: false,
                    polingRunning: false,
                    showTransportEncoding: false,
                    usageCount: 0,
                    uploadInProgress: false
                },
                components: {
                    'modal': {
                        template: '#modal-template',
                    }
                },
                directives: {
                    focus: {
                        inserted: function (el) {
                            el.focus();
                        }
                    }
                },
                watch: {
                    model: {
                        handler: function (value) {
                            if (value.TranscoderInfo.IsRunning == true)
                                _this.StartPolingTrancodes(undefined);
                            else
                                _this.StopPolingTrancodes();
                            _this.vueRoot.$nextTick(function () {
                                fitty('.fitty');
                            });
                        },
                        deep: true
                    }
                },
                computed: {
                    AccessibleByUser: {
                        get: function () {
                            return this.model.SecurityInfo.Level === 4;
                        },
                        set: function (newValue) {
                            if (newValue)
                                this.model.SecurityInfo.Level = 4;
                            else
                                this.model.SecurityInfo.Level = 8;
                        }
                    },
                    CustomThumbnail: {
                        get: function () {
                            var ct = window.Enumerable.from(this.model.Items)
                                .where(function (item) { return item.Purpose == "userthumbnail"; })
                                .select(function (item) { return item; })
                                .toArray();
                            return ct.length == 0 ? null : ct[0];
                        },
                        set: function (newValue) {
                            if (newValue == null) {
                                var ct = window.Enumerable.from(this.model.Items)
                                    .where(function (item) { return item.Purpose == "userthumbnail"; })
                                    .select(function (item) { return item; })
                                    .toArray();
                                this.RemoveRecord('model.Items', this.model.Items.indexOf(ct[0]));
                            }
                            else
                                this.model.Items.push(newValue);
                        }
                    }
                },
                methods: {
                    InitRetranscode: function () {
                        console.log("InitRetranscode");
                        _this.InitRetranscode();
                    },
                    SaveAndPublish: function () {
                        _this.PerformSaveAndPublish();
                    },
                    Update: function (event) {
                        if (_this.vueRoot.$validator !== undefined && _this.vueRoot.$validator.validateAll !== undefined) {
                            _this.vueRoot.$validator.validate('*').then(function () {
                                if (_this.vueRoot.errors.items.length > 0) {
                                    new Noty({
                                        text: "Speichern nicht möglich. Kontrollieren Sie bitte Ihre Eingaben.",
                                        type: 'error',
                                        theme: 'metroui',
                                        timeout: 6000
                                    }).show();
                                    return false;
                                }
                                else
                                    _this.vueRoot.PerformUpdate();
                            });
                        }
                        else {
                            _this.vueRoot.PerformUpdate();
                        }
                    },
                    PerformUpdate: function () { return __awaiter(_this, void 0, void 0, function () {
                        var key, transport, encoding, loadingNoty, infoTimeout;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    for (key in this.vueRoot.model.Items) {
                                        transport = this.vueRoot.model.Items[key].Transport;
                                        encoding = this.vueRoot.model.Items[key].Encoding;
                                        if (((transport == null || transport == '') && (encoding != null && encoding != '')) || ((transport != null && transport != '') && (encoding == null || encoding == ''))) {
                                            new Noty({
                                                text: "Speichern nicht möglich. Wenn Transport angegeben ist, muss auch Encoding angegeben werden und umgekehrt.",
                                                type: 'error',
                                                theme: 'metroui',
                                                timeout: 6000
                                            }).show();
                                            return [2, false];
                                        }
                                    }
                                    if (this.vueRoot.model.hasOwnProperty("Room") && this.vueRoot.model.hasOwnProperty("RoomId"))
                                        this.vueRoot.model.RoomId = this.vueRoot.model.Room.Id;
                                    if (this.vueRoot.model.hasOwnProperty("Location") && this.vueRoot.model.hasOwnProperty("LocationId"))
                                        this.vueRoot.model.LocationId = this.vueRoot.model.Location.Id;
                                    loadingNoty = new Noty({
                                        text: "Der Prozess wurde gestartet. Haben Sie einen Moment Geduld.",
                                        type: 'info',
                                        theme: 'metroui'
                                    });
                                    infoTimeout = window.setTimeout(function () {
                                        loadingNoty.show();
                                    }, 1000);
                                    if (!(this.GetDeletetItems().length > 0)) return [3, 2];
                                    return [4, this.DeleteItems(this.GetDeletetItems())];
                                case 1:
                                    _a.sent();
                                    _a.label = 2;
                                case 2:
                                    KendoDataExtracter_1.KendoDataExtracter.SetKendoDatasourceEntryFromObject(this.vueRoot.model, this.remoteDataSource.at(0));
                                    if (this.options.IsInEditMode)
                                        this.remoteDataSource.at(0).dirty = true;
                                    this.remoteDataSource.sync().always(function () {
                                        window.clearTimeout(infoTimeout);
                                        loadingNoty.close();
                                    });
                                    return [2];
                            }
                        });
                    }); },
                    DeleteItem: function () {
                        _this.StopPolingTrancodes();
                        _this.remoteDataSource.remove(_this.remoteDataSource.at(0));
                        _this.remoteDataSource.sync()
                            .done(function () {
                            var n = new Noty({
                                text: "Klicken Sie hier um zur Übersicht zu gelangend. Sie werden in kürze automatisch weitergeleitet. ",
                                type: 'info',
                                theme: 'metroui',
                                timeout: 3000, callbacks: {
                                    onClose: function () {
                                        document.location.href = "./";
                                    }
                                }
                            }).show();
                        });
                    },
                    AddNewRecord: function (model, type) {
                        var obj = _this.GetVueModel(model);
                        obj.push(_this.GetNewInstanceOfType(type));
                        if (_this && _this.vueRoot) {
                            _this.vueRoot.$nextTick(function () {
                                fitty('.fitty');
                            });
                        }
                    },
                    AskForRemoveRecord: function (model, index) {
                        if (index < 0) {
                            console.log("ContentDetailController -> initVue -> AskForRemoveRecord: no item at the index " + index);
                            return;
                        }
                        var obj = _this.GetVueModel(model);
                        obj.splice(index, 1);
                    },
                    RemoveRecord: function (model, index) {
                        if (index < 0) {
                            console.log("ContentDetailController -> initVue -> RemoveRecord: no item at the index " + index);
                            return;
                        }
                        var obj = _this.GetVueModel(model);
                        obj.splice(index, 1);
                        try {
                            $('#accParent .order-collapse .collapse').collapse('hide');
                        }
                        catch (e) {
                            console.log(e);
                        }
                    },
                    ShowDeleteConfirm: function () {
                        this.showModal = true;
                    },
                    CloseConfirm: function () {
                        this.showModal = false;
                    },
                    DeleteProceed: function () {
                        var dataItem = _this.remoteDataSource.at(0);
                        _this.remoteDataSource.remove(dataItem);
                        _this.remoteDataSource.sync();
                        _this.vueRoot.CloseConfirm();
                    },
                    DsGetNewInstanceOfType: function (type) {
                        return _this.GetNewInstanceOfType(type);
                    },
                    GetData: function () {
                        console.log("getdata");
                        this.options = window.optionslist;
                    },
                    GetLocationsOptionsAsync: function () {
                        jQuery.get(_this.locationsOptionsGetUrl).then(function (response) {
                            _this.vueRoot.locations = response;
                        }, function (response) {
                            new Noty({
                                text: "Die Locations konnten leider nicht abgefragt werden",
                                type: 'error',
                                theme: 'metroui',
                                timeout: 6000
                            }).show();
                        });
                    },
                    GetRoomsOptionsAsync: function () {
                        jQuery.get(_this.roomsOptionsGetUrl).then(function (response) {
                            _this.vueRoot.rooms = response;
                            _this.FireEvent(_this.events.roomsLoaded, response);
                        }, function (response) {
                            new Noty({
                                text: "Räume konnten leider nicht abgefragt werden",
                                type: 'error',
                                theme: 'metroui',
                                timeout: 6000
                            }).show();
                            _this.FireEvent(_this.events.roomsLoadFailed, response);
                        });
                    },
                    GetTenantsOptionsAsync: function () {
                        jQuery.get(_this.tenantsOptionsGetUrl).then(function (response) {
                            _this.vueRoot.tenants = response;
                            _this.FireEvent(_this.events.tenantsLoaded, response);
                        }, function (response) {
                            new Noty({
                                text: "Kunden konnten leider nicht abgefragt werden",
                                type: 'error',
                                theme: 'metroui',
                                timeout: 6000
                            }).show();
                            _this.FireEvent(_this.events.tenantsLoadFailed, response);
                        });
                    },
                    GetItemsByPurpose: function (purpose) {
                        if (!_this.vueRoot)
                            return [];
                        var items = window.Enumerable.from(_this.vueRoot.model.Items)
                            .where(function (item) { return item.Purpose == purpose; })
                            .select(function (item) { return item; })
                            .toArray();
                        return items;
                    },
                    OnCustomThumbnailUploadStarted: function (sender) {
                        _this.vueRoot.uploadInProgress = true;
                    },
                    OnCustomThumbnailUploadCompleted: function (sender) {
                        _this.vueRoot.uploadInProgress = false;
                    },
                    OnCustomThumbnailUploadFailed: function (sender) {
                        _this.vueRoot.uploadInProgress = false;
                        new Noty({
                            text: "Beim Upload ist leider ein Fehler passiert. Probieren Sie es noch einmal. <br />\n                            M\u00F6gliche Ursachen: Fehlerhafte Datei oder Unterbrechung der Internetverbindung.",
                            type: 'error',
                            theme: 'metroui',
                            timeout: 8000
                        }).show();
                    },
                    OnCustomThumbnailUploadAborted: function (sender) {
                        _this.vueRoot.uploadInProgress = false;
                    },
                    UpdatePreviewHeight: function (event) {
                        if (_this.vueRoot.$refs.preview && _this.vueRoot.$refs.preview[0]) {
                            _this.vueRoot.$refs.preview.forEach(function (element) {
                                if (element.offsetWidth > 0) {
                                    var aspect = element.getAttribute("data-aspect-ratio");
                                    element.style.height = element.offsetWidth * aspect;
                                }
                            });
                        }
                    },
                    calcAspectRatio: function (width, height) {
                        if (_this && _this.vueRoot) {
                            _this.vueRoot.$nextTick(function () {
                                this.UpdatePreviewHeight();
                            });
                        }
                        return (height ? height : 1080) / (width ? width : 1920);
                    },
                    breakify: function (text) {
                        var entityMap = {
                            '&': '&amp;',
                            '<': '&lt;',
                            '>': '&gt;',
                            '"': '&quot;',
                            "'": '&#39;',
                            '/': '&#x2F;',
                            '`': '&#x60;',
                            '=': '&#x3D;'
                        };
                        var escaped = String(text).replace(/[&<>"'`=\/]/g, function (s) {
                            return entityMap[s];
                        });
                        return String(escaped).replace(/\n/g, function (s) {
                            return "<br />";
                        });
                    }
                },
                mounted: function () {
                    this.$nextTick(function () {
                        window.addEventListener('resize', this.UpdatePreviewHeight);
                        fitty('.fitty');
                        this.UpdatePreviewHeight();
                    });
                }
            });
            $('select2').on("change", function (e) {
                var fieldname = $(e.currentTarget).attr("data-id");
                if (_this.vueRoot.model.hasOwnProperty(fieldname))
                    _this.vueRoot.model[fieldname] = $(e.currentTarget).val();
            });
        };
        ContentDetailController.prototype.PerformSaveAndPublish = function () {
            var _this = this;
            var a = function () {
                _this.PerformPublish();
                console.log("remove", _this.RemoveEventListener("updated", a));
            };
            this.AddEventListener("updated", a);
            this.vueRoot.Update();
        };
        ContentDetailController.prototype.PerformPublish = function () {
            var _this = this;
            console.log("publish");
            var loadingNoty = new Noty({
                text: "Der Veröffentlichungs-Prozess wurde gestartet. Haben Sie einen Moment Geduld.",
                type: 'info',
                theme: 'metroui'
            });
            var loadingNotyTimeout = window.setTimeout(function () {
                loadingNoty.show();
            }, 500);
            $.ajax({
                method: "PUT",
                url: "/api/v1/virtualscreens/updatecontent/" + this.vueRoot.model.Id,
                contentType: "application/json",
                dataType: "json"
            })
                .done(function (r) {
                new Noty({
                    text: "Der Befehl wurde erfolgreich ausgeführt. Es wurde(n) " + r.UpdatedCount + " Anzeige(n) aktualisiert.",
                    type: 'success',
                    theme: 'metroui',
                    timeout: 2000
                }).show();
            })
                .fail(function (r) {
                _this.DSErrorHandler(r);
            })
                .always(function () {
                window.clearTimeout(loadingNotyTimeout);
                loadingNoty.close();
            });
        };
        ContentDetailController.prototype.GetDeletetItems = function () {
            var dsItems = this.remoteDataSource.data()[0].Items;
            var itemsToDelete = [];
            for (var _i = 0, dsItems_1 = dsItems; _i < dsItems_1.length; _i++) {
                var dsItem = dsItems_1[_i];
                itemsToDelete.push(dsItem);
            }
            for (var _a = 0, dsItems_2 = dsItems; _a < dsItems_2.length; _a++) {
                var dsItem = dsItems_2[_a];
                for (var _b = 0, _c = this.vueRoot.model.Items; _b < _c.length; _b++) {
                    var item = _c[_b];
                    if (dsItem.Id == item.Id) {
                        var index = -1;
                        for (var i = 0; i < itemsToDelete.length; i++) {
                            if (itemsToDelete[i].Id == item.Id) {
                                index = i;
                                break;
                            }
                        }
                        if (index > -1)
                            itemsToDelete.splice(index, 1);
                    }
                }
            }
            return itemsToDelete;
        };
        ContentDetailController.prototype.DeleteItems = function (itemsToDelete) {
            var _this = this;
            return new Promise(function (resolve) {
                var sendCount = 0;
                for (var i = 0; i < itemsToDelete.length; i++) {
                    var url = _this.options.subItemDeleteApiUrl.replace(/{itemId}/g, _this.vueRoot.model.Id).replace(/{subitemId}/g, itemsToDelete[i].Id);
                    $.ajax({
                        method: "DELETE",
                        url: url,
                        contentType: "application/json",
                        dataType: "json"
                    })
                        .then(function (response) {
                    }, function (response) {
                        _this.DSErrorHandler(response);
                    }).always(function (response) {
                        sendCount++;
                        if (sendCount >= itemsToDelete.length)
                            resolve();
                    });
                }
            });
        };
        ContentDetailController.prototype.StartPolingTrancodes = function (responce) {
            var _this = this;
            if (this.vueRoot.polingRunning)
                return false;
            this.vueRoot.polingRunning = true;
            this.polingInterval = window.setInterval(function () {
                jQuery.get(_this.options.readApiUrl).then(function (asset) {
                    console.log("(<Asset>asset).TranscoderInfo.IsRunning:", asset.TranscoderInfo.IsRunning);
                    for (var i = _this.vueRoot.model.Items.length - 1; i >= 0; i--) {
                        if (_this.vueRoot.model.Items[i].Purpose != "main" && _this.vueRoot.model.Items[i].Purpose != "userthumbnail")
                            _this.vueRoot.model.Items.splice(i, 1);
                    }
                    for (var key in asset.Items) {
                        if (asset.Items[key].Purpose != "main" && asset.Items[key].Purpose != "userthumbnail")
                            _this.vueRoot.model.Items.push(asset.Items[key]);
                    }
                    if (asset.TranscoderInfo.IsRunning == false) {
                        _this.vueRoot.model.TranscoderInfo.IsRunning = false;
                        window.clearInterval(_this.polingInterval);
                    }
                }, function (response) {
                    window.clearInterval(_this.polingInterval);
                    new Noty({
                        text: "Der Befehl konnte leider nicht ausgeführt werden.",
                        type: 'error',
                        theme: 'metroui',
                        timeout: 6000
                    }).show();
                });
            }, 2000);
        };
        ContentDetailController.prototype.StopPolingTrancodes = function () {
            window.clearInterval(this.polingInterval);
            this.vueRoot.polingRunning = false;
        };
        ContentDetailController.prototype.InitRetranscode = function () {
            var _this = this;
            this.vueRoot.model.TranscoderInfo.IsRunning = true;
            jQuery.get(this.retranscodeApiUrl).then(function (response) { return _this.StartPolingTrancodes(response); }, function (response) {
                _this.vueRoot.model.TranscoderInfo.IsRunning = false;
                new Noty({
                    text: "Der Befehl konnte leider nicht ausgeführt werden.",
                    type: 'error',
                    theme: 'metroui',
                    timeout: 6000
                }).show();
            });
        };
        ContentDetailController.prototype.DSReqestEndHandler = function (e) {
            _super.prototype.DSReqestEndHandler.call(this, e);
            if (e.type == "update")
                this.FireEvent("updated");
        };
        return ContentDetailController;
    }(BasicViewControllerWithCRUDDataSource_1.BasicViewControllerWithCRUDDataSource));
    exports.ContentDetailController = ContentDetailController;
    $(function () {
        var optionsList = window["ContentDetailControllerData"];
        for (var i in optionsList) {
            window["ContentDetailController" + i] = new ContentDetailController(optionsList[i]);
        }
    });
});
//# sourceMappingURL=ContentDetailController.js.map


//////////////////
// WEBPACK FOOTER
// ./wwwroot/js/Controllers/ContentDetailController.js
// module id = 392
// module chunks = 0